// extracted by css-extract-rspack-plugin
export default {"stats-legend":"JQDZ1Kel","stats-legend__item":"qgzXmpcV","stats-legend__code":"vNl_n07U","stats-legend__label":"EjyeytBT"};